// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"checkBox_checkBox__WNXgB","checkBoxSelected":"checkBox_checkBoxSelected__3UM35"};